<template>
  <li ref="treeItem">
    <div class="tree-node-div" @mouseover="changeHover(index)" @mouseout="currentHover = -1"
      :class="[currentHover == index ? 'tr-hover' : '', $store.state.clickItem == model || $store.state.syncClickItem == model && transferAimFlag ? 'tr-click' : 'tr-0d0s7', $store.state.arr.includes(model) || $store.state.syncArr.includes(model) ? 'tr-click' : 'tr-0d0s9']"
      @click="chooseItem(model)">
      <span @click.stop="toggle(index, model)" class="tr-height tr-tree-span">
        <i class="icon-util  pull-triangle-position" v-if="testShow(model)"
          :class="[model.open ? 'down-triangle' : 'pull-triangle']"></i>
        <i class="icon-util  pull-triangle-position" style="width:20Px;height:20Px;" v-if="!testShow(model)"></i>
      </span>
      <div class="tr-tree-span">
        <i v-loading='loading' class="folder-position "
          :class="[model.appName ? returnName(model.appName) : 'small-file', model.dir ? matchfolderType(model.docType) + '-small' : '', !model.dir && !model.appName ? matchfileType(model.name) + '-small' : '']"></i>
        <span ref="treeItemName" :title="model.name" class="tr-tree-name-span"
          @dblclick.stop="toggle(index, model)">{{ model.name }}</span>
        <div class="tree-innerclass" ref="editTreeName"
          :class="$store.state.isTreeflage ? 'tree-innerclass' : 'tree-innerclass-not'">
          <input :class="$store.state.isTreeflage ? 'tree-name-edit' : 'tree-name-not'" v-model="inputValue" @click.stop=""
            @focus="isTreeflage = true" @blur.stop="submitFolder(model)" />
          <span class="tree-input-icon">
            <i class="icon-util name-sure" @click.stop='submitFolder(model)'></i>
            <i class="icon-util name-cancel " @mousedown.stop='cancelNewFolder(model)'></i>
          </span>
        </div>

      </div>
      <i class="add-more-photos-icon2" :data-id="model.id" v-show="this.isShowAddMorePhotos(model)" @click.stop="createSession(model)" :title="$t('language.popup.cloudExploerPopup.googlePhotosV2AddMore')"></i>
      <i v-show="((((treeShow && model.driveType != 'googlePhotos') || (treeShow && (model.driveType == 'googlePhotos' && model.id == '/albums')))) && backupSource != true) && this.isShowNewFolder(model)"
        @click.stop="addNewFolder(index, model, 'FOLDER')" class="icon-util add-folder-positon"
        :class="[$store.state.isTreeflage && currentHover == index ? 'add-folder' : '']"></i>
      <i v-show="this.isShowNewAlbum(model)" @click.stop="addNewFolder(index, model, 'ALBUM')"
        class="icon-util add-folder-positon" :class="[$store.state.isTreeflage && currentHover == index ? 'add-album' : '']"></i>
    </div>
    <ul v-show="model.open">
      <tree-menu :key="index" v-for="(item, index) in model.children" :backupSource="backupSource" :treeShow="treeShow"
        :model="item" :index=index :transferAimFlag='transferAimFlag'></tree-menu>
    </ul>
    <!-- <onedriveBusinesFolderError ref="onedriveBusinesFolderError"></onedriveBusinesFolderError> -->
    <googlePhotosV2CreateDialog ref="googlePhotosV2CreateDialog" @createFolder="handleCreateFolderGooglePhotos"></googlePhotosV2CreateDialog>
  </li>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import '@/assets/css/tree.css';
import commonstate from '@/js/constant.js';
// import onedriveBusinesFolderError from "@/components/workspace/list_onedrivebuiness_folder_error";
import googlePhotosV2CreateDialog from "@/components/popup/cloud_exploer_popups/google_photos_v2_create_popup";
import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
export default {
  components: {
        // onedriveBusinesFolderError,
        googlePhotosV2CreateDialog,
    },
  name: 'treeMenu',
  props: ['model', 'index', 'treeShow', 'transferAimFlag', 'backupSource', 'isFrom'],
  data: function () {
    return {
      open: false,
      hasChild: true,
      currentHover: -1,
      activeClass: '',
      inputValue: null,
      treeIndex: 0,
      loading: false,
      reName: null,
      syncFlag: false,
      i: 0,
      realTimeMode: false,
      googlePhotosV2CurDriveId:'',
      curNode: null,
      curIndex: 0,
    }
  },
  methods: {
    // GooglePhotosV2创建会话
    handleCreateFolderGooglePhotos(folderName){
        let mkdirData = new cloudExploerUtils.mkdirData("/", commonUtils.getUser().id, this.googlePhotosV2CurDriveId, folderName);
        mkdirData.ty = 'FOLDER';
        var that = this;
        that.Utils.doFilesRequest("mkdir", mkdirData).then(res => {
            if (res.status == 200) {
                // 并且打开页面让用户选择
                window.open(res.item.webUrl);
                if (this.curNode) {
                  // 局部刷新页面
                  if (this.curNode.open) {
                    // 折叠
                    this.toggle(this.curIndex, this.curNode);
                    // 重置
                    this.curNode.children = undefined;
                    // 展开
                    this.toggle(this.curIndex, this.curNode);
                  } else {
                    // 重置，用户展开时会刷新
                    this.curNode.children = undefined;
                  }
                } else {
                  // 全局刷新页面
                  location.reload();
                }
            } else {
                // 创建失败
                that.$message({
                    type: 'error',
                    message: res.msg
                });
            }
        });
    },
    // 创建会话或跳转
    createSession(model) {
      if (model.rootId == "/") {
          this.googlePhotosV2CurDriveId = model.id;
          this.$refs.googlePhotosV2CreateDialog.createShow = true;
          this.curIndex = this.index;
          this.curNode = model;
        } else if (model.id && model.id.startsWith("/session/") && model.webUrl && model.webUrl.startsWith("http")) {
          window.open(model.webUrl);
        }
    },
    // 是否显示添加更多图片图标
    isShowAddMorePhotos(model) {
      let flag = false;
      if (model.driveType == "googlePhotosV2") {
        if (model.rootId == "/") {
          flag = true;
        } else if (model.id && model.id.startsWith("/session/") && model.webUrl && model.webUrl.startsWith("http")) {
          flag = true;
        }
      }
      return flag;
    },
    //若为SharePoint的根目录和站点目录，返回false则不会显示新建文件夹图标
    isShowNewFolder(model) {
      let flag = true;
      if (model.driveType == 'sharePointOnline') {
        var folderId = model.id;
        var newId = folderId.split(':')[0];
        if (model.rootId == 'root0' || newId == 'site') {
          flag = false;
        }
      }
      //iCloudPhotos docType=="ALBUM"，不显示新建文件夹
      if (model.driveType == "iCloudPhotos" && model.docType == "ALBUM") {
        flag = false;
      }
      // GooglePhotosV2仅Albums显示新建文件夹
      if (model.driveType == "googlePhotosV2") {
        flag = (model.id == "/albums");
      }
      return flag;
    },
    isShowNewAlbum(model) {
      let flag = false;
      //iCloudPhotos docType=="FOLDER"，显示新建相簿
      if (model.driveType == "iCloudPhotos" && (!model.docType || model.docType == "FOLDER")) {
        flag = true;
      }
      return flag;
    },
    returnName(appName) {
      let result;
      if (appName != 'ownCloud') {
        result = 'icon ' + appName + '-small';
      } else {
        result = 'icon ' + appName + '-small-box';
      }
      return result;
    },
    testShow(model) {
      let flag;
      if (!model.open) {
        flag = true;
      } else {
        if (model.children && !model.children.length) {
          flag = false;
        } else {
          flag = true;
        }
      }
      if (this.backupSource && !model.children) {
        flag = false;
      }
      return flag;
    },
    //打开云备份目录源
    openBackupSource(index, model, callback) {
      this.hasChild = this.model.children;
      if (!model.open) {
        model.open = true;
      } else {
        // if (this.hasChild &&this.hasChild.length) {
        model.open = false;
        // }
      }
      this.loading = false;
      this.$forceUpdate();
    },
    toggle: function (index, model, callback) {
      if (this.backupSource) {
        this.openBackupSource(index, model, callback);
        return;
      }
      if (model.id) {
        let that = this;
        let modelItem = Object.assign({}, model);
        delete modelItem.children;
        this.hasChild = this.model.children;
        let transferFromOpen = this.$store.state.transferFromOpen;
        if (this.hasChild) {
          if (!model.open) {
            if (model.children && model.children.length) {
              let pnode;
              //防止创建任务时node丢失
              if (model.children[0] && !model.children[0].pnode) {
                if (model.rootId) {
                  pnode = {
                    id: model.rootId,
                    name: model.appName
                  }
                } else {
                  pnode = {
                    id: model.id,
                    name: model.name
                  }
                }
                $.each(model.children, function (i, item1) {
                  item1.newParam = 'pnode';
                  item1.pnode = pnode;
                });
              }

            }
            model.children = commonUtils.packageDataChildren(model.children);
          }
          if (!model.open) {
            model.open = true;
          } else {
            if (this.hasChild.length) {
              model.open = false;
            }
          }
          that.loading = false;
          this.$forceUpdate();
        } else {
          this.googleGuideFlag2XY(model);
          let driveId;
          let fileId;
          let type;
          that.loading = true;
          if (model.appName) {
            driveId = model.id;
            fileId = model.rootId;
            this.$store.commit('setTreeDriveId', driveId);
          } else {
            driveId = model.driveId;
            fileId = model.id;
          }
          type = model.driveType;
          let listData = {
            ud: commonUtils.getUserToLocal().id,
            dd: driveId,
            id: fileId
          }
          that.Utils.doFilesRequest("list", listData).then(res => {
            that.loading = false;
            if (res.status == 200) {
              if (model && !model.children) {
                model.newParam = 'children';
                model.children = commonUtils.packageData(commonUtils.sortArr(res.items, true, 0), driveId,
                  fileId,
                  transferFromOpen, type);
                let arr1 = new Array;
                arr1 = model.children;
                $.each(arr1, function (i, item1) {
                  item1.newParam = 'pnode';
                  item1.pnode = modelItem;
                  if (model.driveInfo && model.driveInfo.afterBackup != undefined) {
                    item1.afterBackup = model.driveInfo.afterBackup;
                  } else {
                    if (!model.afterBackup) {
                      model.afterBackup = false;
                    }
                    item1.afterBackup = model.afterBackup;
                  }
                });
              } else if (model.children) {
                model.children = commonUtils.packageData(commonUtils.sortArr(res.items, true, 0), driveId,
                  fileId,
                  transferFromOpen, type);
                let arr2 = new Array;
                arr2 = model.children;
                $.each(arr2, function (j, item2) {
                  item2.newParam = 'pnode';
                  item2.pnode = modelItem;
                  if (model.driveInfo && model.driveInfo.afterBackup != undefined) {
                    item2.afterBackup = model.driveInfo.afterBackup;
                  } else {
                    if (!model.afterBackup) {
                      model.afterBackup = false;
                    }
                    item2.afterBackup = model.afterBackup;
                  }
                });
              }
              this.toggle(index, model, function (message) { });
              if (callback != undefined) {
                callback(res);
              }
              // 谷歌相册V2新手引导
              if (this.isFrom) {
                let cookieKey = "googlePhotosV2TipsTaskFrom" + commonUtils.getUser().id;
                let isNew = this.$cookies.get(cookieKey) != "Y";
                if(type=="googlePhotosV2" && model.rootId=="/" && isNew) {
                    var arr = model.children;
                    if (arr==undefined || arr.length==2) {
                      this.$store.state.googleGuideFlag2 = true;
                      this.$cookies.set(cookieKey, "Y", "1y");
                    }
                }
              }
            } 
            // else if (model.driveType == "oneDrive4Business" && res.msg.includes("Access denied")) {
            //             this.$toast({
            //             text: that.$t('language.exception.accessDenied'),
            //             type: 'fail',
            //             idValue: "rightContBan"
            //              });
            //                   // 弹窗
            //         that.$refs.onedriveBusinesFolderError.taskMultiShows = true;
            // }
             else {
              if (type == "googlePhotosV2" && res.msg.includes("project_number:744933414389") && res.msg.includes("RESOURCE_EXHAUSTED")) {
                  this.$toast({
                      text: 'Sorry! The Google Photos service has reached its daily request limit. Please try again later.',
                      type: 'fail',
                      idValue: "rightContBan"
                  });
              } else if (type == "googlePhotosV2" && res.msg.includes("google_photos_v2_not_select")) {
                  this.$toast({
                      text: this.$t('language.popup.cloudExploerPopup.googlePhotosV2NotSelect'),
                      type: 'notice',
                      idValue: "rightContBan"
                  });
              } else {
                this.$toast({
                  text: this.$t('language.exception.' + res.reason),
                  type: 'fail',
                  idValue: "rightContBan"
                });
              }
            }
          });
        }
      }
    },
    changeHover(index) {
      this.currentHover = index;
    },
    // 设置谷歌相册V2新手引导坐标
    googleGuideFlag2XY(model) {
      try {
        const treeRef = this.$refs.treeItem;
        const nodeEl = treeRef.querySelector(`.add-more-photos-icon2[data-id="${model.id}"]`);
        if (nodeEl) {
          const rect = nodeEl.getBoundingClientRect();
          const pageX = rect.left + window.scrollX;
          const pageY = rect.top + window.scrollY;
          this.$store.state.googleGuideFlag2X = pageX - 7;
          this.$store.state.googleGuideFlag2Y = pageY - 7;
        }
      } catch (error) {
        
      }
    },
    chooseItem(model) {
      // 谷歌相册V2新手引导
      if (this.isFrom) {
        let cookieKey = "googlePhotosV2TipsTaskFrom" + commonUtils.getUser().id;
        let isNew = this.$cookies.get(cookieKey) != "Y";
        if(model.driveType=="googlePhotosV2" && model.rootId=="/" && isNew) {
            var arr = model.children;
            if (arr==undefined || arr.length==2) {
              this.googleGuideFlag2XY(model);
              this.$store.state.googleGuideFlag2 = true;
              this.$cookies.set(cookieKey, "Y", "1y");
            }
        }
      }
      this.i = 0;
      let that = this;
      let continueFlag;

      // if(this.$store.state.treeRealTimeMode && model.driveType == 'google_drive' && !this.transferAimFlag){
      //     this.$toast({
      //     text: this.$t('language.cloudSync.gooleFolder'),
      //     type: 'notice',
      //     idValue: 'rightContBan',
      //    });
      // }
      if (this.$store.state.treeRealTimeMode && model.driveType == 'box' && !model.pnode) {
        this.$toast({
          text: this.$t('language.exception.InvalidDirectory'),
          type: 'fail',
          idValue: 'rightContBan',
          learnMoreShow: false
        });
        return;
      }
      //判断是否存在不支持的目标目录
      if (this.transferAimFlag == true || this.transferAimFlag == 'CopyTo' || this.transferAimFlag == 'cloudBackup' ||
        this.transferAimFlag == 'syncAim' || this.transferAimFlag == 'remoteTask') {
        if (this.transferAimFlag == 'CopyTo' && this.$store.state.exploerselectedArr.length > 0) {
          if (this.$store.state.exploerselectedArr[0].pid == model.id && model.driveId == this.$store.state
            .exploerselectedArr[0].driveId) {
            this.cloudExploerWarn();
            continueFlag = false;
            return false;
          }
          if (this.$store.state.exploerselectedArr[0].pid == model.rootId && model.id == this.$store.state
            .exploerselectedArr[0].driveId) {
            this.cloudExploerWarn();
            continueFlag = false;
            return false;
          }
          $.each(this.$store.state.exploerselectedArr, function (i, sourceItem) {
            if (model.id == sourceItem.id && model.driveId == sourceItem.driveId) {
              that.cloudExploerWarn();
              continueFlag = false;
              return false;
            }
            if (model.pnode) {
              let flag = commonUtils.checkNode(model.pnode, sourceItem);
              if (flag) {
                that.cloudExploerWarn();
                continueFlag = false;
                return false;
              }
            }
          });
        }
        if (model.driveType == 'googlePhotosV2') {
          if (this.transferAimFlag == 'cloudBackup') {
            this.notSelectGoolePhoto();
            return;
          }
          var selectId = model.id;
          if (model.rootId == "/") {
            this.notTransferingWarn();
          } else if (selectId == "/albums") {
            this.$toast({
              text: this.$t('language.popup.cloudExploerPopup.googlePhotosV2SelectAlbums'),
              type: 'notice',
              idValue: 'rightContBan',
              learnMoreShow: false
            });
            this.selectItem(model);
          } else if (selectId && selectId.indexOf("/albums/") >= 0) {
            this.$toast({
              text: this.$t('language.popup.cloudExploerPopup.googlePhotosV2SelectAlbum'),
              type: 'notice',
              idValue: 'rightContBan',
              learnMoreShow: false
            });
            this.selectItem(model);
          } else if (selectId == "/photos") {
            this.$toast({
              text: this.$t('language.popup.cloudExploerPopup.googlePhotosV2SelectPhotos'),
              type: 'notice',
              idValue: 'rightContBan',
              learnMoreShow: false
            });
            this.selectItem(model);
          } else if (selectId && selectId.indexOf("/session/") >= 0) {
            this.$toast({
              text: this.$t('language.popup.cloudExploerPopup.googlePhotosV2SelectSession'),
              type: 'fail',
              idValue: 'rightContBan',
              learnMoreShow: false
            });
          } else {
            this.selectItem(model);
          }
        } else if (model.driveType == 'googlePhotos') {
          if (this.transferAimFlag == 'cloudBackup') {
            this.notSelectGoolePhoto();
            return;
          }
          if (model.id == '/sharing' || commonstate.googlePhotos.includes(model.rootId)) {
            this.notTransferingWarn();
          } else if (model.id == '/albums') {
            this.selectItem(model);
            this.notMediaFilesWarn();
          } else if (model.id == '/photos') {
            if (this.transferAimFlag == true || this.transferAimFlag == 'remoteTask') {
              let that = this;
              let leftSource = this.$parent.$parent.$parent.mulitDrives;
              let leftArr = [];
              $.each(leftSource, function (index, leftItem) {
                leftArr.push(leftItem.dir);
              });
              if (leftArr.length && leftArr[0] == false && commonUtils.isAllEqual(leftArr)) {
                this.selectItem(model);
              } else {
                this.notStoreDirectoriesWarn();
              }
            }
            if (this.transferAimFlag == 'CopyTo' || this.transferAimFlag == 'remoteTask' || this.transferAimFlag == 'syncAim') {
              this.selectItem(model);
              this.onlyStoreImagesWarn();
            }
          } else {
            if (model.writeable) {
              this.selectItem(model);
              this.selectAlbumWarn();
            } else {
              this.onlyAlbumWarn();
            }
          }
        } else if (model.driveType == 'iCloudPhotos') {
          if (this.transferAimFlag == 'cloudBackup') {
            //备份任务不允许成为目标
            this.notSelectCloudPhotosBackup();
            return;
          }
          if (model.rootId == 'root') {
            this.notSelectICloudPhotosRoot();
            //设置根目录为文件夹
            model.docType = 'FOLDER';
          }
          if (model.dir) {
            if (model.docType == 'FOLDER') {
              this.notSelectICloudPhotosForder();
            }
            if (model.docType == 'ALBUM') {
              this.notSelectICloudPhotosAlbum();
            }
            if (model.pid == 'root' && (model.name == 'Favorites' || model.name == 'Hiddens')) {
              this.notSelectICloudPhotosOther();
            }
          }
          this.selectItem(model);
        } else if (model.driveType == 'gSuite' && model.rootId == '/') {
          this.notTransferingWarn();
        } else if (model.driveType == 'gSuiteSharedDrive') {
          let id = model.rootId ? model.rootId : model.id; let path = id.split(":");
          // 根目录及成员目录
          if (path.length == 2) {
            this.notTransferingWarn();
          } else {
            this.selectItem(model);
          }
        } else if (model.driveType == 'google_drive_sharedWithMe' && model.rootId == "sharedWithMe") {
          this.notTransferingWarn();
        } else if (model.driveType == 'boxBusiness' && model.rootId == "/") {
          this.notTransferingWarn();
        } else if ((model.driveType == 'sugarSync' && (model.name != 'Web Archive' && model.name !=
          'Magic Briefcase' &&
          model.name != 'Mobile Photos' && !this.testPnodeName(model)))) {
          this.sugarSyncWarn();
        } else if (model.driveType == 'flickr') {
          if (this.transferAimFlag == 'cloudBackup') {
            this.notSelectFilker();
            return;
          }
          if (model.rootId == '/') {
            this.flickWarn();
            return;
          }
          this.selectItem(model);
        } else if (model.driveType == 'baiDu' && model.id != null && !model.id.startsWith('/apps/Multcloud')) {
          this.baiDuWarn();
        } else if (model.driveType == 'dropbox4Business' && (model.rootId == '/' || model.id == 'Members')) {
          this.dropBoxbusinessWarn();
        } else if (model.driveType == 'mySQL') {
          this.mySqlWarn();
        } else if (model.driveType == 'wasabi' && model.rootId == 'root0') {
          this.notTransferingWarn();
        } else if (model.driveType == 'iDrivee2' && model.rootId == 'root0') {
          this.notTransferingWarn();
        } else if (model.driveType == 'sharePointOnline' && (model.rootId == 'root0' || this.isSiteDirectory(model))) {
          this.sharePointOnlineNotTransWarn();
        } else if (model.driveType == 'oneDrive4Business' && model.rootId == 'admin') {
          this.notTransferingWarn();
        } else if (continueFlag != false) {
          this.selectItem(model);
        }
      } else {
        this.selectItem(model);
      }
    },
    testPnodeName(model) {
      let nameArr = ['Web Archive', 'Magic Briefcase', 'Mobile Photos'];
      if (model.pnode) {
        this.i = this.i + 1;
        if (this.i >= 2) {
          this.syncFlag = true;
        }
        if (nameArr.includes(model.pnode.name)) {
          this.syncFlag = true;
        }
        this.testPnodeName(model.pnode);
      }
      return this.syncFlag;
    },
    selectItem(model) {
      if (this.transferAimFlag != 'syncAim') {
        let that = this;
        if (this.$store.state.multiSelect) {
          this.$store.commit('setClickItem', -1);
          if (this.$store.state.arr.includes(model)) {
            this.$store.state.arr = this.$store.state.arr.filter(
              function (ele) {
                return ele != model;
              });
          } else {
            this.$store.commit('setArr', model);
          }
        } else {
          that.$store.state.arr = [];
          that.$store.commit('setClickItem', model);
          that.$store.commit('setArr', model);
        }
      } else {
        if (this.$store.state.syncMultiSelect) {
          this.$store.commit('setSyncClickItem', -1);
          if (this.$store.state.syncArr.includes(model)) {
            this.$store.state.syncArr = this.$store.state.syncArr.filter(
              function (ele) {
                return ele != model;
              });
          } else {
            this.$store.commit('setSyncArr', model);
          }
        } else {
          this.$store.state.syncArr = [];
          this.$store.commit('setSyncClickItem', model);
          this.$store.commit('setSyncArr', model);
        }

      }
    },
    matchfileType(fileName) {
      return commonUtils.matchfileTypes(fileName);
    },
    matchfolderType(docType) {
      return docType ? docType == 'ALBUM' ? 'album' : 'folder' : 'folder';
    },
    //点击新建文件夹
    addNewFolder(index, model, type) {
      let that = this;
      this.hasChild = model.children && model.children.length;
      if (this.$store.state.isTreeflage) {
        //如果该文件夹打开过
        if (this.hasChild || this.hasChild == 0) {
          model.open = true;
          if (!model.children) {
            model.children = new Array;
          }
          let JsonList = that.judgeRepeatFolderName(model, type);
          $.each(model.children, function (i, item) {
            JsonList.push(item);
          });
          model.children = JsonList;
          that.$forceUpdate();
          that.$nextTick(function () {
            that.editInputStyle("inline-block", "none", model);
          })
        } else {
          //如果该文件夹没打开
          that.toggle(index, model, function (message) {
            if (message.status == 200) {
              let JsonList = that.judgeRepeatFolderName(model, type);
              $.each(model.children, function (i, item) {
                JsonList.push(item);
              });
              model.children = JsonList;
              that.$forceUpdate();
              that.$nextTick(function () {
                that.editInputStyle("inline-block", "none", model);
              })

            }
          });
        }
      }
    },
    editInputStyle(inputDomStye, divDomStyle, model) {
      let inputDom = this.$children[1].$refs.editTreeName;
      let divDom = this.$children[1].$refs.treeItemName;
      this.$children[1].inputValue = model.children[0].name;
      inputDom.style.display = inputDomStye;
      divDom.style.display = divDomStyle;
      this.$nextTick(function () {
        inputDom.children[0].select();
      });
    },
    editDivStyle(inputDomStye, divDomStyle) {
      let inputDom = this.$refs.editTreeName;
      let divDom = this.$refs.treeItemName;
      if (inputDom && inputDom.style) {
        inputDom.style.display = inputDomStye;
      }
      if (divDom && divDom.style) {
        divDom.style.display = divDomStyle;
      }
    },
    cancelNewFolder(model) {
      let that = this;
      this.$store.state.isTreeflage = false;
      let children = model.pnode.children;
      children.splice(0, 1);
      this.$nextTick(function () {
        this.editDivStyle("none", "");
      })
      let t = setTimeout(() => {
        that.$store.state.isTreeflage = true;
        clearTimeout(t);
      }, 500);
    },
    submitFolder(model) {
      if (this.$store.state.isTreeflage) {
        this.$store.state.isTreeflage = false;
        this.$forceUpdate();
        let tid;
        let dd;
        let driveType;
        let pnode;
        let that = this;
        let nameArr = [];
        for (let i = 1; i < model.pnode.children.length; i++) {
          nameArr.push(model.pnode.children[i].name);
        }
        commonUtils.includesFileName(nameArr, that.inputValue, this);
        that.inputValue = that.reName;
        if (model.pnode.rootId) {
          tid = model.pnode.rootId;
          dd = model.pnode.id;
        } else {
          tid = model.pnode.id;
          dd = model.pnode.driveId;
        }
        driveType = model.pnode.driveType;
        pnode = model.pnode;
        let mkdirData = {
          tid: tid,
          ud: commonUtils.getUserToLocal().id,
          dd: dd,
          n: that.inputValue
        }
        if (model.docType) {
          mkdirData.ty = model.docType;
        }
        if (that.inputValue) {
          model.name = that.inputValue;
        }
        //如果包含特殊字符则提示
        if (commonstate.pattern.test(that.inputValue)) {
          model.pnode.children.splice(0, 1);
          that.editDivStyle("none", "");
          that.$forceUpdate();
          that.$store.state.isTreeflage = true;
          that.$toast({
            text: that.$t('language.cloudExploer.notContainSpecialChar'),
            type: 'fail',
            idValue: 'rightContBan',
          });
          return;
        } else if (that.inputValue.endsWith('.') || that.inputValue.startsWith('..')) { // 不能以点结尾
          model.pnode.children.splice(0, 1);
          that.editDivStyle("none", "");
          that.$forceUpdate();
          that.$store.state.isTreeflage = true;
          that.$toast({
            text: that.$t('language.cloudExploer.notWith'),
            type: 'fail',
            idValue: 'rightContBan',
          });
          return;
        }
        this.Utils.doFilesRequest("mkdir", mkdirData).then(res => {
          if (res.status == 200) {
            var data = JSON.parse(JSON.stringify(res.item));
            model.modifiedTime = data.modifiedTime;
            if (res.cloudType == 4) {
              model.modifiedTime = that.getCurrentLong();
              model.size = 0;
            }
            if (model.afterBackup == undefined && model.pnode.driveInfo.afterBackup != undefined) {
              if (!model.pnode.driveInfo.afterBackup) {
                model.pnode.driveInfo.afterBackup = false;
              }
              model.afterBackup = model.pnode.driveInfo.afterBackup;
            }
            if (model.afterBackup == undefined && model.pnode.afterBackup != undefined) {
              if (!model.pnode.afterBackup) {
                model.pnode.afterBackup = false;
              }
              // that.selectItem(model);不再选中未新增的文件夹
              model.afterBackup = model.pnode.afterBackup;
            }
            if (data.name) {
              model.name = data.name;
            }
            model.dir = data.dir;
            model.id = data.id;
            model.driveId = dd;
            model.pid = tid;
            model.driveType = driveType;
            model.pnode = pnode;
            let key = tid + dd;
            let tableData = that.$store.state.cacheTableDatas[key];
            if (tableData) {
              tableData.tableData.push(model);
              that.$store.commit("setCacheTableDatas", {
                id: key,
                tableData: tableData.tableData
              });
            }
            let JsonList = [];
            JsonList.push(model);
            model.pnode.children.splice(0, 1);
            $.each(model.pnode.children, function (i, item) {
              JsonList.push(item);
              if (i == model.pnode.children.length - 1) {
                model.pnode.children = JsonList;
                let t = setTimeout(function () {
                  that.editDivStyle("none", "");
                  clearTimeout(t);
                  that.$store.state.isTreeflage = true;
                }, 2000);
                return false;
              }
            });
            if (!model.pnode.children.length) {
              model.pnode.children = JsonList;
              let t = setTimeout(function () {
                that.editDivStyle("none", "");
                clearTimeout(t);
                that.$store.state.isTreeflage = true;
              }, 2000);
            }
            that.chooseItem(model);
          } else {
            model.pnode.children.splice(0, 1);
            that.editDivStyle("none", "");
            that.$forceUpdate();
            //将该创建文件夹设置为可用
            that.$store.state.isTreeflage = true;
            that.$toast({
              text: that.$t('language.exception.createFolderFail'),
              type: 'fail',
              idValue: 'rightContBan',
            });
          }
        });
      }
    },
    getCurrentLong() {
      var nowDate = new Date();
      var year = nowDate.getFullYear();
      var month = nowDate.getMonth() + 1;
      var today = nowDate.getDate();
      var hours = nowDate.getHours();
      var minutes = nowDate.getMinutes();
      var seconds = nowDate.getSeconds();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (today >= 1 && today <= 9) {
        today = "0" + today;
      }
      var currentdate = year + "-" + month + "-" + today + " " + hours + ":" + minutes + ":" + seconds;
      var currentDateLong = new Date(currentdate.replace(new RegExp("-", "gm"), "/")).getTime() //当前时间转换成long型
      return currentDateLong;
    },
    judgeRepeatFolderName(model, docType) {
      let childrens = model.children;
      let JsonList = [];
      let defaultName = "New ";
      if (docType == "ALBUM") {
        defaultName += "Album";
      } else {
        defaultName += "Folder";
      }
      var afterBackup;
      var name = defaultName;
      var j = 0;
      for (let i = 0; i < childrens.length; i++) {
        if (childrens[i].name == name) {
          j = j + 1;
          name = defaultName + "(" + j + ")";
          i = -1;
          continue;
        }
      }
      if (model.afterBackup != undefined) {
        afterBackup = model.afterBackup;
      }
      let newItem = {
        name: name,
        dir: true,
        afterBackup: afterBackup,
        driveType: model.driveType,
        docType: docType,
      };
      newItem.pnode = model;
      //googlePhotos文件夹需要设置为自建
      if (model.driveType == 'googlePhotos') {
        newItem.writeable = true;
      }
      JsonList.push(newItem);
      return JsonList;
    },
    // 判断所选目录是不是SharePoint站点目录
    isSiteDirectory(model) {
      let flag = false;
      var folderId = model.id;
      var newId = folderId.split(':')[0];
      if (newId == 'site') {
        flag = true;
      }
      return flag;
    },
    notSelectGoolePhoto() {
      this.$store.state.syncClickItem = -1;
      this.$store.state.clickItem = -1;
      this.$store.state.syncArr = [];
      this.$store.state.arr = [];
      this.$toast({
        text: this.$t('language.cloudBackup.backupFiles'),
        type: 'fail',
        idValue: 'rightContBan',
        learnMoreShow: true
      });
    },
    notSelectCloudPhotosBackup() {
      this.$store.state.syncClickItem = -1;
      this.$store.state.clickItem = -1;
      this.$store.state.syncArr = [];
      this.$store.state.arr = [];
      this.$toast({
        text: this.$t('language.exception.notSelectICloudPhotosBackup'),
        type: 'fail',
        idValue: 'rightContBan',
      });
    },
    notSelectICloudPhotosRoot() {
      this.$toast({
        text: this.$t('language.exception.notSelectICloudPhotosRoot'),
        type: 'note',
        idValue: 'rightContBan',
      });
    },
    notSelectICloudPhotosForder() {
      this.$toast({
        text: this.$t('language.exception.notSelectICloudPhotosForder'),
        type: 'note',
        idValue: 'rightContBan',
      });
    },
    notSelectICloudPhotosAlbum() {
      this.$toast({
        text: this.$t('language.exception.notSelectICloudPhotosAlbum'),
        type: 'note',
        idValue: 'rightContBan',
      });
    },
    notSelectICloudPhotosOther() {
      this.$toast({
        text: this.$t('language.exception.notSelectICloudPhotosOther'),
        type: 'note',
        idValue: 'rightContBan',
      });
    },
    notSelectFilker() {
      this.$store.state.syncClickItem = -1;
      this.$store.state.clickItem = -1;
      this.$store.state.syncArr = [];
      this.$store.state.arr = [];
      this.$toast({
        text: this.$t('language.cloudBackup.backFlickr'),
        type: 'fail',
        idValue: 'rightContBan',
        learnMoreShow: true
      });
    },
    notTransferingWarn() {
      this.$toast({
        text: this.$t('language.exception.notTransferring'),
        type: 'fail',
        idValue: 'rightContBan',
        learnMoreShow: true
      });
    },
    // sharePointOnline选择根目录作为目标的错误提示
    sharePointOnlineNotTransWarn() {
      this.$toast({
        text: this.$t('language.exception.sharePointOnlineNotTrans'),
        type: 'fail',
        idValue: 'rightContBan',
        learnMoreShow: false
      });
    },
    notMediaFilesWarn() {
      this.$toast({
        text: this.$t('language.exception.notMediaFiles'),
        type: 'notice',
        idValue: 'rightContBan',
        learnMoreShow: false
      });
    },
    notStoreDirectoriesWarn() {
      this.$toast({
        text: this.$t('language.exception.notStoreDirectories'),
        type: 'fail',
        idValue: 'rightContBan',
        learnMoreShow: true
      });
    },
    onlyStoreImagesWarn() {
      this.$toast({
        text: this.$t('language.exception.onlyStoreImages'),
        type: 'notice',
        idValue: 'rightContBan',
        learnMoreShow: true
      });
    },
    sugarSyncWarn() {
      this.$toast({
        text: this.$t('language.exception.sugarSyncWarn'),
        type: 'fail',
        idValue: "rightContBan",
        learnMoreShow: true
      });
    },
    flickWarn() {
      this.$toast({
        text: this.$t('language.exception.flickWarn'),
        type: 'fail',
        idValue: 'rightContBan',
        learnMoreShow: true
      });
    },
    baiDuWarn() {
      this.$toast({
        text: this.$t('language.exception.baiDuWarn'),
        type: 'fail',
        idValue: 'rightContBan',
        learnMoreShow: true
      });
    },
    dropBoxbusinessWarn() {
      this.$toast({
        text: this.$t('language.exception.dropBoxbusinessWarn'),
        type: 'fail',
        idValue: 'rightContBan',
        learnMoreShow: true
      });
    },
    mySqlWarn() {
      this.$toast({
        text: this.$t('language.exception.mySqlWarn'),
        type: 'fail',
        idValue: 'rightContBan',
        learnMoreShow: true
      });
    },
    onlyAlbumWarn() {
      this.$toast({
        text: this.$t('language.exception.onlyAlbum'),
        type: 'fail',
        idValue: 'rightContBan',
        learnMoreShow: true
      });
    },
    selectAlbumWarn() {
      this.$toast({
        text: this.$t('language.exception.selectAlbumWarn'),
        type: 'notice',
        idValue: 'rightContBan',
      });
    },
    cloudExploerWarn() {
      this.$toast({
        text: this.$t('language.common.selectOther'),
        type: 'fail',
        idValue: 'rightContBan',
        learnMoreShow: true
      });
    },
    getIdValue() {
      let idValue;
      if (this.transferAimFlag == 'CopyTo') {
        idValue = 'CopyTo';
      } else if (this.transferAimFlag == 'syncAim') {
        idValue = 'transferAim'
      } else {
        idValue = 'pleaseSelect'
      }
      return idValue;
    }

  },
  filters: {
    ellipsis(value) {
      if (!value) return '';
      if (value.length > 40) {
        return value.slice(0, 40) + '...';
      }
      return value;
    }
  }
}
</script>

<style>
#pleaseSelect ul,
#sourceSelect ul,
#transferAim ul {
  list-style: none;
  color: #6f7886;
  margin: 0;
  padding-left: 15px;
  /*no*/
  display: block;
  list-style-type: disc;
  margin-inline-start: 0px;
  margin-inline-end: 0px;

}

#pleaseSelect li,
#sourceSelect li,
#transferAim li {
  list-style: none;
  text-align: left;
  white-space: nowrap;
  margin: 0;
}

#pleaseSelect .tree-node-div,
#sourceSelect .tree-node-div,
#transferAim .tree-node-div {
  word-break: keep-all;
  white-space: nowrap;
  min-width: 300px;
  /*no*/
  height: 40px;
  /*no*/
  overflow: hidden;
}

.tree-innerclass {
  width: 180px;
  /*no*/
  height: 35px;
  /*no*/
  float: left;
  display: none;
}

.tree-innerclass-not {
  width: 180px;
  /*no*/
  height: 35px;
  /*no*/
  float: left;
  display: none;
  pointer-events: none;
}

.tree-name-edit {
  background: #fff !important;
  margin-top: 7px;
  /*no*/
  height: 25px;
  /*no*/
  width: 180px;
  /*no*/
  float: left;
  font-size: 14px;
  /*no*/
  padding: 0px 45px 0px 5px;
  /*no*/
  float: left;
  border: 1px solid #4181ff !important;
  /*no*/
  box-sizing: border-box;
}

.tree-name-not,
.tree-name-not:hover {
  background: #fff !important;
  margin-top: 7px;
  /*no*/
  height: 25px;
  /*no*/
  width: 180px;
  /*no*/
  float: left;
  font-size: 14px;
  /*no*/
  padding: 0px 45px 0px 5px;
  /*no*/
  float: left;
  border: 1px solid #cdcdcd !important;
  /*no*/
  box-sizing: border-box;
  position: relative;
  pointer-events: none;
  cursor: pointer;

}

.tree-input-icon {
  width: 40px;
  /*no*/
  height: 25px;
  /*no*/
  position: relative;
  left: -47px;
  /*no*/
  top: 7px;
  /*no*/
}

.tree-node-div {
  position: relative;
}

#syncTaskSingle .tree-node-div:hover>.add-more-photos-icon2 {
  display: inline-block;
}

.add-more-photos-icon2 {
    width: 30px;
    height: 30px;
    border-radius: 15px;
    display: none;
    position: absolute;
    right: 20px;
    top: 4px;
    background-size: 13px;
    background-position: 10px 8px;
    background-repeat: no-repeat;
    background-image: url("../../../assets/images/vectorImg/add_more_photos.png");
}

.add-more-photos-icon2:hover {
  background-color: #0000002c;
}
</style>



// WEBPACK FOOTER //
// src/components/common/trees/tree.vue